import { Vue, Component } from 'vue-property-decorator';
import { vxm } from '@/store';

@Component
export default class Base extends Vue {
    protected authorityListTop: any[] = [
        { text: '顧客', value: 0 },
        { text: '一般', value: 1 },
        { text: '管理者', value: 2 },
        { text: 'システム管理者', value: 3, disabled: true },
    ];
    protected authorityList: any[] = [
        { text: '顧客', value: 0 },
        { text: '一般', value: 1 },
        { text: '管理者', value: 2 },
    ];

    // UserStore
    // ユーザID
    protected get userId(): number {
        return vxm.user.user_id;
    }
    // ユーザアカウント
    protected get userAccount(): string {
        return vxm.user.user_account;
    }
    // ユーザ名
    protected get userName(): string {
        return vxm.user.user_name;
    }
    // ユーザ権限
    protected get authority(): number {
        return vxm.user.authority;
    }
    // グループID
    protected get groupId(): number {
        return vxm.user.group_id;
    }
    // アクセストークン
    protected get token(): string {
        return vxm.user.token;
    }
    // ユーザID
    protected get corpId(): number {
        return vxm.user.corp_id;
    }

    // CommonStore
    // ローディング状態
    protected get loadingState(): boolean {
        return vxm.common.loading_state;
    }

    protected validationErrors: any = {}; // エラーメッセージ

    // バリデーションルール（必須チェック）
    protected rulesRequired(name: string, value: any): boolean | string {
        if (!value) {
            return name + 'が入力されていません';
        }
        return true;
    }

    // バリデーションルール（必須チェック）
    protected rulesRequiredSelect(name: string, value: any): boolean | string {
        if (value === '') {
            return name + 'を選択してください';
        }
        return true;
    }
    // バリデーションルール（必須チェック）
    protected rulesRequiredSelectCorp(name: string, value: number): boolean | string {
        if (value == 0) {
            return name + 'を選択してください';
        }
        return true;
    }

    // バリデーションルール（メール形式チェック）
    protected rulesEmail(mail_address: string): boolean | string {
        if (!/.+@.+\..+/.test(mail_address)) {
            return 'メールアドレスの形式で入力してください';
        }
        return true;
    }
    // バリデーションルール（パスワード一致チェック）
    protected rulesPasswordConfirm(password: string, password_confirm: string): boolean | string {
        if (password !== password_confirm) {
            return 'パスワードが一致しません';
        }
        return true;
    }
    // バリデーションルール（数値チェック）
    protected rulesNumber(numVal: string): boolean | string {
        // チェック条件パターン
        var pattern = /^[-]?([1-9]\d*|0)(\.\d+)?$/;
        // 数値チェック
        if (!pattern.test(numVal)) {
            return '数値で入力してください';
        }
        return true;
    }
    // バリデーションルール（数値の大小チェック）
    protected rulesNumberHighLow(numHigh: number, numLow: number): boolean | string {
        if (Number(numHigh) <= Number(numLow)) {
            return 'しきい値限界はしきい値注意より小さい値で設定してください';
        }
        return true;
    }
    // バリデーションルール（半角数値とカンマ）
    protected rulesNumberAndComma(numVal: string): boolean | string {
        // チェック条件パターン
        var pattern = /^[0-9,]*$/;
        // 数値チェック
        if (!pattern.test(numVal)) {
            return '半角数値とカンマで入力してください';
        }
        return true;
    }

    // サーバーからのバリデーションエラーの削除
    protected emptyError(v: any) {
        this.$set(this.validationErrors, v, '');
    }

    created() {
        // Alertの内容をリセット
        this.$store.dispatch('common/setAlertParamsAc', {
            is_display: false,
            type: 'white',
            timeout: -1,
            message: '',
            return_flg: false,
        });
    }
}
